import React, { useState } from "react";
import { Outlet, Route, Routes } from "react-router-dom"; // Import Outlet and Routes

import Header from "../components/AdminDashBoard/commonPage/Header";
import Sidebar from "../components/AdminDashBoard/commonPage/Sidebar";
import Courses from "../components/AdminDashBoard/SidebarPages/Courses";
import Resources from "../components/AdminDashBoard/SidebarPages/Resources";
import Students from "../components/AdminDashBoard/SidebarPages/Students";
import CourseCategory from "../components/AdminDashBoard/SidebarPages/CourseCategory";
import Teachers from "../components/AdminDashBoard/SidebarPages/Teachers";
import Simple from "../components/AdminDashBoard/SidebarPages/Simple";
import PaymentHistory from "../components/AdminDashBoard/SidebarPages/PaymentHistory";
import ClassRooms from "../components/AdminDashBoard/SidebarPages/ClassRooms";
import { useAxiosInterceptors } from "../services/api";
import MessageListPage from "../components/AdminDashBoard/SidebarPages/MessageListPage";
// Adjust the import path as necessary

const AppLayout = () => {
	const [sidebarOpen, setSidebarOpen] = useState(false);
	useAxiosInterceptors();

	return (
		<div className="flex h-screen   ">
			<Sidebar
				sidebarOpen={sidebarOpen}
				setSidebarOpen={setSidebarOpen}
			/>
			<div className="flex-1 flex flex-col">
				<Header
					sidebarOpen={sidebarOpen}
					setSidebarOpen={setSidebarOpen}
				/>
				<main className="flex-1 overflow-y-auto p-4">
					<Routes>
						<Route path="courses" element={<Courses />} />
						<Route path="resources" element={<Resources />} />
						<Route path="students" element={<Students />} />
						<Route
							path="courseCategory"
							element={<CourseCategory />}
						/>
						<Route path="teachers" element={<Teachers />} />
						<Route path="simple" element={<Simple />} />
						<Route path="payments" element={<PaymentHistory />} />
						<Route path="classRooms" element={<ClassRooms />} />
						<Route path="chats" element={<MessageListPage />} />
						<Route path="*" element={<Courses />} />
					</Routes>
					<Outlet /> {/* This will render nested routes if any */}
				</main>
			</div>
		</div>
	);
};

export default AppLayout;
